// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2JdY0","requiredAsterisk":"Info_requiredAsterisk__16zXZ"};